import { useCurrentURL } from "../hooks/ContextualNavigations";
import { decryptParams } from "./obfuscate";
import config from "../config/default";
import { applicationListRules } from "./applicationRules";
import { selectApplication } from "./selectApplication";
import { hasDedicatedBrandDomain } from "../branding/brandRegistry";

export { applicationListRules };

export const CurrentApplication = () => {
  const params = useCurrentURL();

  // Lógica legada preservada em selectApplication; aqui só injetamos o travamento por
  // domínio dedicado de marca (após isIDP). Ver openspec change (D3).
  return selectApplication(
    { url: params.url, rules: params.rules },
    config.isIDP,
    hasDedicatedBrandDomain(window.location.hostname)
  );
};

export const showPass = (showPass: boolean) => {
  return showPass ? "text" : "password";
};

export const getParams = async () => {
  const hash = window.location.hash || "";

  const [, rawParams] = hash.split("?");

  if (!rawParams) {
    const message = "Nenhum parâmetro encontrado no hash:";
    console.warn(message, hash);
    return {};
  }

  const queryString = new URLSearchParams(rawParams);

  const queryParams = Object.fromEntries(queryString.entries());

  const encryptedPayload = queryString.get("payload");

  if (encryptedPayload) {
    try {
      const decrypted = await decryptParams(encryptedPayload);
      return { ...queryParams, ...decrypted };
    } catch (e) {
      console.error("Erro ao descriptografar payload. ", e);
      return queryParams;
    }
  }

  return queryParams;
};
